import { useStaticQuery, graphql } from 'gatsby'

const FindLocalImage = filename => {
  const imagelocalquery = useStaticQuery(
    graphql`
      query {
        localimages: allFile(filter: { sourceInstanceName: { eq: "images" } }) {
          edges {
            node {
              base
              childImageSharp {
                square: fluid(maxWidth: 1200, quality: 80) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
    `,
  )

  const imgarray = [...imagelocalquery.localimages.edges]

  const queriedpost = imgarray.find(n => {
    if (filename) {
      return n.node.base.includes(filename)
    }
  })
  if (!queriedpost) {
    return null
  }

  return queriedpost
  // return null
}

export default FindLocalImage
